import * as React from 'react';
import { CardElement, injectStripe } from 'react-stripe-elements';

interface StripeCheckoutFormProps {
    stripe: any;
    sendStripeToken: (id: string, email: string) => any;
    email: string;
}

interface StripeCheckoutFormState {
    complete: boolean;
}

class StripeCheckoutForm extends React.Component<StripeCheckoutFormProps, StripeCheckoutFormState> {
    constructor(props: StripeCheckoutFormProps) {
        super(props);
        this.state = {
            complete: false
        };
        this.submit = this.submit.bind(this);
    }

    async submit(ev: any) {
        let { token } = await this.props.stripe.createToken({ name: "Name" });
        /*
        let response = await fetch("/charge", {
            method: "POST",
            headers: { "Content-Type": "text/plain" },
            body: token.id
        });
        */
        if (token && token.id) {
            console.log("id_stripe", token.id);
            this.props.sendStripeToken(token.id, this.props.email);
        }
    }
    render() {
        return (
            <div className="checkout">
                <p> <span style={{ lineHeight: '34px' , fontSize: 20 }}> Credit Card (Stripe) 100% Secure On Line Payment  </span>  <i style={{ fontSize: 25 }} className='fa fa-credit-card' />    <i style={{ fontSize: 25 }} className='fa fa-cc-stripe' />   <i style={{ fontSize: 25 }} className='fa fa-cc-visa' />   <i style={{ fontSize: 25 }} className='fa fa-cc-mastercard' />   <i style={{ fontSize: 25 }} className='fa fa-cc-discover' />   <i style={{ fontSize: 25 }} className='fa fa-cc-amex' /> </p>
            <div className="col-md-6"><CardElement /></div>
            <div className="col-md-6"><button className="btn btn-primary form-control" style={{ height: '36.8px', margin: "10px 0 20px 0" }} onClick={this.submit}>Pay Now</button></div>
            </div >
        );
    }
}

export default injectStripe(StripeCheckoutForm);



// WEBPACK FOOTER //
// ./src/new-booking/StripeCheckoutForm.tsx